export const _footerFr = {
    legalNotice: 'Mentions Légales',
    termsOfService: 'Conditions Générales d\'Utilisation',
    privacyPolicy: 'Politique de confidentialité',
    termsOfSales: 'Conditions Générales de Vente',
    credits: 'Crédits',
};

export const _footerEn = {
    legalNotice: 'Legal Notice',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    termsOfSales: 'Terms of Sales',
    credits: 'Credits',
};

export const _footerDe = {
    legalNotice: 'Impressum',
    termsOfService: 'Nutzungsbedingungen',
    privacyPolicy: 'Datenschutz-Bestimmungen',
    termsOfSales: 'Verkaufsbedingungen',
    credits: 'Credits',
};
